import * as React from "react";
import { styled, TextField } from "@mui/material";
import { ReactNode, useEffect, useRef, useState } from "react";
import { CommonColors } from "../colors/commonColors";
import { TextHighlight } from "fe-common/commonTypes/errors";
import { FormInputHighlight } from "./formInputHighlight";

//region [[ Styles ]]

const InputAndChildrenWrapper = styled("div")({
  display: "flex",
  flexFlow: "row",
  alignItems: "center",
  justifyContent: "flex-start",
  position: "relative",
  width: "100%",
  // "& > *:nth-child(2)": {
  //   marginLeft: "5px",
  //   marginRight: "5px",
  // },
  "& .with_highlighter, & .highlighter": {
    backgroundColor: "transparent",
    border: "unset",
    borderRadius: "5px",
    lineHeight: 1.44
  },
  "& .MuiSelect-outlined.MuiSelect-outlined": {
    paddingLeft: 14,
    paddingTop: 14,
    paddingBottom: 14,
  },
});

const ErrorText = styled("div")({
  color: "red",
  fontSize: 14,
});

const StyledLabel = styled("div")({
  color: CommonColors.TextMain,
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 1.2,
  marginBottom: 5,
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface FormInputProps {
  className?: string;
  id?: string;
  name?: string;
  label?: string;
  type?: string;
  value?: string;
  placeHolder?: string;
  onChange?: (event) => void;
  error?: string;
  onKeyDown?: (event) => void;
  inputPrefix?: ReactNode;
  inputSuffix?: ReactNode;
  disabled?: boolean;
  children?: ReactNode;
  customInput?: ReactNode;
  style?: React.CSSProperties;
  inputStyle?: React.CSSProperties;
  autoComplete?: string;
  required?: boolean;
  multiline?: boolean;
  minRows?: number;
  maxRows?: number;
  highlights?: TextHighlight[];
  margin?: number | string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const FormInput = ({ ...props }: FormInputProps) => {

  const [highLightMode, setHighlightMode] = useState(
    !!props.highlights?.length,
  );
  const highlighter = useRef(null);
  const inputRef = useRef(null);
  useEffect(() => {
    setHighlightMode(!!props.highlights?.length);
  }, [props.highlights]);

  useEffect(() => {
    if (props.highlights?.length && inputRef.current) {
      inputRef.current.scrollTop = 0;
    }
  }, [props.highlights]);

  return (
    <div className={"clinic-input " + props.className} style={props.style}>
      {props.label && <StyledLabel>{props.label}</StyledLabel>}
      <InputAndChildrenWrapper>
        {highLightMode && (
          <FormInputHighlight
            highlights={props.highlights}
            {...props}
            ref={highlighter}
          />
        )}

        {props.customInput || (
          <TextField
            id={props.id || ""}
            variant="outlined"
            type={props.type || "text"}
            value={props.value}
            onChange={(e) => {
              setHighlightMode(false);
              props.onChange(e);
            }}
            onKeyDown={props.onKeyDown}
            disabled={props.disabled}
            fullWidth
            required={props.required}
            InputLabelProps={{ shrink: false }}
            inputProps={{
              name: props.name,
              startAdornment: props.inputPrefix,
              endAdornment: props.inputSuffix,
              autoComplete: props.autoComplete,
              style: props.inputStyle,
              onScroll: (e) => {
                if (highLightMode) {
                  highlighter.current.scrollTop = (e.target as any).scrollTop;
                }
              }}
            }
            placeholder={props.placeHolder}
            multiline={props.multiline}
            minRows={props.minRows}
            maxRows={props.maxRows}
            inputRef={inputRef}
          />
        )}
        {props.children}
      </InputAndChildrenWrapper>
      {props.error && <ErrorText>{props.error}</ErrorText>}
    </div>
  );
};
